import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, rem, typeface, typography } from './../../../styles';
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1ps9lxi",
  styles: "border-right:none;input~&,textarea~&{border-bottom-right-radius:inherit;border-top-right-radius:inherit;}"
} : {
  name: "1dsg48v-defaultStyles",
  styles: "border-right:none;input~&,textarea~&{border-bottom-right-radius:inherit;border-top-right-radius:inherit;};label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles(_ref3) {
  var isFirst = _ref3.isFirst,
    isLast = _ref3.isLast;
  return /*#__PURE__*/css("align-items:center;background-color:", colors.transparent, ";color:", colors.coolGray_800, ";display:flex;font-family:", typeface.typefaceBase, ";font-size:", typography.typographyBodyXs, ";font-weight:", typography.typographyFontWeightSemiBold, ";justify-content:center;line-height:", typography.typographyLineHeightMi, ";padding:", rem(1, 12), ";transition:box-shadow 0.2s;input~&,textarea~&{border-right:", rem(1), " solid ", colors.coolGray_500, ";}", isFirst && /*#__PURE__*/css("border-bottom-left-radius:inherit;border-right:", rem(1), " solid ", colors.coolGray_500, ";border-top-left-radius:inherit;input~&,textarea~&{border-bottom-left-radius:0;border-top-left-radius:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), " ", isLast && _ref2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1qm0zur",
  styles: "align-items:stretch;padding:0"
} : {
  name: "uiu3x8-isElementStyles",
  styles: "align-items:stretch;padding:0;label:isElementStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isElementStyles = function isElementStyles(_ref4) {
  var isElement = _ref4.isElement;
  if (isElement) {
    return _ref;
  }
};
var resetStyles = getResetByTag('div');
var StyledFormFieldAffixText = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "ed47beu0"
} : {
  target: "ed47beu0",
  label: "StyledFormFieldAffixText"
})(resetStyles, defaultStyles, isElementStyles);
export default StyledFormFieldAffixText;